import React, { ReactNode } from "react";
import { Title, Subtitle, Uppertitle, Text, HelpText } from "./TypographyStyled";

export interface Props {
	/**  'title' | 'subtitle' | 'uppertitle' | 'text'  */
	variant: "title" | "subtitle" | "uppertitle" | "text" | "helptext";
	/** title: 30px | subtitle: 14px | uppertitle: 20px | text: 14px  */
	size?: string;
	primary?: boolean;
	margin?: string;
	color?: string;
	children?: ReactNode;
	fontWeight?: string;
	uppercase?: boolean;
	display?: string;
	align?: string;
	lineHeight?: string;
	className?: string;
}

const TypographyWrapper: React.FC<Props> = ({ 
	children, 
	margin = "0",
	uppercase = false,
	display = "block",
	align = "left",
	primary = false,
	...props 
}: Props) => (
	<>
		{props.variant === "title" && <Title margin={margin} uppercase={uppercase} display={display} align={align} primary={primary} {...props}>{children}</Title>}
		{props.variant === "subtitle" && <Subtitle margin={margin} uppercase={uppercase} display={display} align={align} primary={primary} {...props}>{children}</Subtitle>}
		{props.variant === "uppertitle" && <Uppertitle margin={margin} uppercase={uppercase} display={display} align={align} primary={primary} {...props}>{children}</Uppertitle>}
		{props.variant === "text" && <Text margin={margin} uppercase={uppercase} display={display} align={align} primary={primary} {...props}>{children}</Text>}
		{props.variant === "helptext" && <HelpText margin={margin} uppercase={uppercase} display={display} align={align} primary={primary} {...props}>{children}</HelpText>}
	</>
);

export { TypographyWrapper as Typography };
